export interface ListCategories {
    listId: string;
    categories: string[];
}

export const emptyListCategories: ListCategories = {
    listId: '',
    categories: []
};